import { trackAdsBannerTeaserEvent } from './analytics';
import { TAnalyticsMessagePayload } from '../../types';

const EVENT_NAMES = ['show_card'];
const MARTECH_BANNER_SOURCES = ['adfox', 'internal'];

export function teaserHandler([, eventParams]: TAnalyticsMessagePayload) {
  const { sc, product, page } = eventParams;

  switch (true) {
    // Для рекламных баннеров всю аналитику нужно отправить
    case !!product && !!product.extra && MARTECH_BANNER_SOURCES.includes(product.extra.bannerSource):
    case EVENT_NAMES.includes(product.name): {
      trackAdsBannerTeaserEvent({ sc, product, page });
      break;
    }
  }
}
